export default __webpack_public_path__ + "static/media/nine.1dcdd2e4.jpeg";